import { render, staticRenderFns } from "./LeadBarChart.vue?vue&type=template&id=14223cdb&scoped=true"
import script from "./LeadBarChart.vue?vue&type=script&lang=ts"
export * from "./LeadBarChart.vue?vue&type=script&lang=ts"
import style0 from "./LeadBarChart.vue?vue&type=style&index=0&id=14223cdb&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14223cdb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14223cdb')) {
      api.createRecord('14223cdb', component.options)
    } else {
      api.reload('14223cdb', component.options)
    }
    module.hot.accept("./LeadBarChart.vue?vue&type=template&id=14223cdb&scoped=true", function () {
      api.rerender('14223cdb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/admin/components/LeadBarChart.vue"
export default component.exports